import { render, staticRenderFns } from "./ddoCartArea.vue?vue&type=template&id=4566eaee&"
import script from "./ddoCartArea.vue?vue&type=script&lang=js&"
export * from "./ddoCartArea.vue?vue&type=script&lang=js&"
import style0 from "./ddoCartArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports